import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CommonService } from '@sharedModule/services/common/common.service';
import { switchMap, map, catchError, of } from 'rxjs';
import {
  loadCountry,
  loadCountrySuccess,
  loadCountryFailure,
} from './country.actions';

@Injectable()
export class CountryEffect {
  loadCountry$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCountry),
      switchMap(() =>
        this.commonService.getCountryList().pipe(
          map(data => loadCountrySuccess({ countries: data.response })),
          catchError(error => of(loadCountryFailure({ error: error.error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private commonService: CommonService
  ) {}
}
